var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBecomeIzPartner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 327",
    style: {
      enableBackground: "new 0 0 700 327"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D6D6D6;}\r\n\t.st1{fill:#CBEDFF;}\r\n\t.st2{fill:#CFDCFF;}\r\n\t.st3{fill:#FAA2A1;}\r\n\t.st4{fill:#DB7170;}\r\n\t.st5{fill:#45596E;}\r\n\t.st6{fill:#48547A;}\r\n\t.st7{fill:#F59F9E;}\r\n\t.st8{fill:#FFFFFF;}\r\n\t.st9{fill:#F15A24;}\r\n\t.st10{fill:#6884A3;}\r\n\t.st11{fill:#0071BC;}\r\n\t.st12{fill:#5F7894;}\r\n\t.st13{fill:#3C3D4D;}\r\n\t.st14{fill:#4C6278;}\r\n\t.st15{fill:#754949;}\r\n\t.st16{fill:#674650;}\r\n\t.st17{fill:#B0727C;}\r\n\t.st18{fill:#586F8A;}\r\n\t.st19{fill:#4D627A;}\r\n\t.st20{fill:#414366;}\r\n\t.st21{fill:#A7A9AC;}\r\n\t.st22{fill:#8F4B59;}\r\n\t.st23{fill:#5D342B;}\r\n\t.st24{fill:#B0BBD9;}\r\n\t.st25{fill:#3B495C;}\r\n\t.st26{fill:#5C656B;}\r\n\t.st27{fill:#7C6B85;}\r\n\t.st28{fill:#66596E;}\r\n\t.st29{fill:#4A5C73;}\r\n\t.st30{fill:#3A3B4D;}\r\n\t.st31{fill:#3B3C4F;}\r\n\t.st32{fill:#2B2C40;}\r\n\t.st33{fill:#CCDFFF;}\r\n\t.st34{fill:#573A43;}\r\n\t.st35{fill:#FBD5A2;}\r\n\t.st36{fill:#EF9796;}\r\n\t.st37{fill:#F28987;}\r\n\t.st38{fill:#835353;}\r\n\t.st39{fill:#49364F;}\r\n\t.st40{fill:#363754;}\r\n\t.st41{fill:#181929;}\r\n\t.st42{fill:#FFB1B0;}\r\n\t.st43{fill:#A16971;}\r\n\t.st44{fill:#422B27;}\r\n\t.st45{fill:#5E3D38;}\r\n\t.st46{fill:#035A6D;}\r\n\t.st47{fill:#00596B;}\r\n\t.st48{fill:#009EB6;}\r\n\t.st49{fill:#021824;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Become IZSoftwares&amp;apos;s partner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.7,293c-1.3-1.5-2.6-3.1-3.9-4.7l2.4-1.8c1.2,1.5,2.5,3.1,3.8,4.6L250.7,293z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.7,282.1l-2.5-1.7c2.2-3.2,4.3-6.6,6.3-10l2.6,1.5C462.2,275.4,460,278.8,457.7,282.1z M239.9,278.5 c-2.2-3.4-4.2-6.9-6.1-10.4l2.7-1.4c1.8,3.5,3.8,6.9,5.9,10.2L239.9,278.5z M469.5,261.2l-2.7-1.2c1.6-3.6,3-7.2,4.3-10.9l2.8,1 C472.7,253.7,471.2,257.5,469.5,261.2L469.5,261.2z M228.8,257.2c-1.5-3.7-2.9-7.5-4-11.3l2.9-0.9c1.1,3.7,2.5,7.5,3.9,11.1 L228.8,257.2z M477.3,238.4l-2.9-0.7c0.9-3.8,1.7-7.7,2.2-11.5l3,0.4C479,230.5,478.3,234.5,477.3,238.4z M221.8,234.2 c-0.8-3.9-1.4-7.9-1.9-11.9l3-0.3c0.4,3.9,1.1,7.8,1.8,11.6L221.8,234.2z M480.8,214.6l-3-0.2c0.1-2.3,0.2-4.6,0.2-6.9 c0-1.6,0-3.3-0.1-4.9l3-0.1c0.1,1.7,0.1,3.3,0.1,5C481,209.9,480.9,212.3,480.8,214.6L480.8,214.6z M219,210.3c0-0.9,0-1.8,0-2.8 c0-3.1,0.1-6.2,0.3-9.3l3,0.2c-0.2,3-0.3,6-0.3,9.1c0,0.9,0,1.8,0,2.7L219,210.3z M476.9,191c-0.5-3.9-1.2-7.8-2-11.6l2.9-0.7 c0.9,3.9,1.6,7.9,2.1,11.9L476.9,191z M223.7,186.9l-3-0.5c0.6-4,1.5-7.9,2.5-11.8l2.9,0.8C225.1,179.1,224.3,183,223.7,186.9 L223.7,186.9z M471.7,168.1c-1.2-3.7-2.6-7.4-4.1-11l2.8-1.2c1.6,3.7,3,7.5,4.2,11.3L471.7,168.1z M229.6,164.2l-2.8-1 c1.4-3.8,2.9-7.5,4.6-11.1l2.7,1.3C232.5,156.8,230.9,160.5,229.6,164.2L229.6,164.2z M462.4,146.5c-1.9-3.4-3.9-6.8-6.1-10 l2.5-1.7c2.2,3.3,4.3,6.8,6.2,10.3L462.4,146.5z M239.6,142.9l-2.6-1.5c2-3.4,4.2-6.8,6.6-10.1l2.4,1.7 C243.7,136.2,241.6,139.5,239.6,142.9z M449.4,127c-2.5-3-5.1-6-7.8-8.8l2.2-2.1c2.8,2.9,5.5,5.9,8,9L449.4,127z M253.3,123.8 l-2.3-2c2.6-3,5.4-6,8.3-8.7l2.1,2.2C258.6,118,255.9,120.8,253.3,123.8L253.3,123.8z M433,110.2c-3-2.5-6.1-5-9.3-7.2l1.7-2.5 c3.3,2.3,6.5,4.8,9.5,7.4L433,110.2z M270.3,107.5l-1.9-2.3c3.1-2.5,6.4-4.9,9.7-7.1l1.6,2.5C276.5,102.8,273.3,105.1,270.3,107.5 L270.3,107.5z M413.8,96.6c-3.4-2-6.9-3.8-10.4-5.4l1.3-2.7c3.6,1.7,7.2,3.5,10.7,5.5L413.8,96.6z M289.9,94.6l-1.4-2.6 c3.5-1.9,7.2-3.6,10.9-5.2l1.2,2.8C296.9,91.1,293.3,92.8,289.9,94.6L289.9,94.6z M392.4,86.9c-3.7-1.3-7.5-2.4-11.3-3.4l0.7-2.9 c3.9,1,7.8,2.1,11.5,3.5L392.4,86.9z M311.5,85.5l-0.9-2.9c3.8-1.2,7.7-2.2,11.6-3.1l0.6,2.9C319.1,83.3,315.2,84.4,311.5,85.5 L311.5,85.5z M369.6,81.1c-3.8-0.6-7.8-1-11.7-1.3l0.2-3c4,0.2,8,0.7,12,1.3L369.6,81.1z M334.5,80.6l-0.4-3c4-0.5,8-0.8,12-0.9 l0.1,3C342.3,79.8,338.3,80.1,334.5,80.6L334.5,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.3,296.3l-2.2-2c1.3-1.4,2.7-2.9,3.9-4.4l2.3,1.9C449,293.3,447.7,294.9,446.3,296.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.5,301c-1.1-1.7-2.2-3.4-3.3-5.1l2.5-1.6c1,1.7,2.1,3.4,3.2,5L211.5,301z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M491.4,296.5l-2.5-1.6c2.1-3.4,4.2-6.9,6-10.4l2.7,1.4C495.6,289.5,493.5,293.1,491.4,296.5z M202.1,285.3 c-1.9-3.6-3.7-7.3-5.3-11.1l2.8-1.2c1.6,3.7,3.4,7.3,5.2,10.9L202.1,285.3z M502.9,274.9l-2.8-1.2c1.6-3.7,3.1-7.4,4.4-11.2l2.8,1 C506.1,267.3,504.5,271.2,502.9,274.9z M192.3,262.8c-1.4-3.8-2.6-7.8-3.6-11.7l2.9-0.8c1,3.9,2.2,7.7,3.6,11.5L192.3,262.8z  M511.1,251.8l-2.9-0.8c1-3.9,2-7.8,2.8-11.7l2.9,0.6C513.1,243.8,512.2,247.8,511.1,251.8L511.1,251.8z M186,239.1 c-0.8-4-1.4-8.1-1.9-12.1l3-0.3c0.5,4,1.1,8,1.8,11.9L186,239.1z M515.8,227.7l-3-0.4c0.5-4,0.8-8,1-12l3,0.1 C516.6,219.6,516.3,223.7,515.8,227.7z M183.1,214.8c-0.1-2.4-0.1-4.8-0.1-7.2c0-1.7,0-3.4,0.1-5.1l3,0.1c0,1.7-0.1,3.3-0.1,5 c0,2.3,0,4.7,0.1,7L183.1,214.8z M514,203.3c-0.1-4-0.4-8.1-0.8-12l3-0.3c0.4,4,0.6,8.1,0.8,12.2L514,203.3z M186.9,190.6l-3-0.3 c0.4-4.1,1-8.1,1.7-12.1l3,0.5C187.8,182.6,187.3,186.6,186.9,190.6z M511.6,179.3c-0.7-3.9-1.5-7.9-2.5-11.8l2.9-0.7 c1,3.9,1.8,8,2.5,12L511.6,179.3z M191.1,166.9l-2.9-0.7c1-3.9,2.2-7.9,3.5-11.8l2.8,1C193.2,159.1,192.1,163,191.1,166.9z  M505.7,156c-1.3-3.8-2.7-7.6-4.2-11.3l2.8-1.1c1.6,3.8,3,7.6,4.3,11.5L505.7,156z M198.8,144l-2.8-1.1c1.6-3.8,3.3-7.5,5.2-11.1 l2.7,1.4C202,136.7,200.3,140.4,198.8,144z M496.5,133.7c-1.8-3.6-3.8-7.1-5.8-10.5l2.6-1.5c2.1,3.5,4.1,7.1,5.9,10.7L496.5,133.7z  M209.7,122.5l-2.6-1.5c2.1-3.5,4.4-6.9,6.8-10.3l2.4,1.7C214,115.8,211.8,119.2,209.7,122.5L209.7,122.5z M484.1,113.1 c-2.3-3.3-4.8-6.5-7.3-9.6l2.3-1.9c2.6,3.1,5.1,6.4,7.4,9.8L484.1,113.1z M223.7,103l-2.3-1.9c2.6-3.1,5.4-6.2,8.2-9.1l2.2,2.1 C229,96.9,226.3,99.9,223.7,103z M468.8,94.6c-2.8-2.9-5.7-5.7-8.6-8.4l2-2.2c3,2.7,6,5.6,8.8,8.6L468.8,94.6z M240.4,85.6l-2-2.2 c3-2.7,6.2-5.4,9.4-7.9l1.8,2.4C246.5,80.3,243.4,82.9,240.4,85.6z M451,78.4c-3.2-2.5-6.4-4.9-9.8-7.1l1.7-2.5 c3.4,2.3,6.7,4.7,9.9,7.2L451,78.4z M259.4,70.9l-1.7-2.5c3.4-2.3,6.9-4.4,10.4-6.4l1.5,2.6C266.2,66.5,262.7,68.6,259.4,70.9z  M431,65c-3.5-2-7.1-3.9-10.7-5.6l1.3-2.7c3.7,1.8,7.3,3.7,10.9,5.7L431,65z M280.4,59.1l-1.3-2.7c3.7-1.7,7.5-3.3,11.3-4.8 l1.1,2.8C287.7,55.8,284,57.4,280.4,59.1z M409.2,54.6c-3.7-1.5-7.6-2.8-11.4-3.9l0.9-2.9c3.9,1.2,7.8,2.5,11.6,4L409.2,54.6z  M302.8,50.5l-0.8-2.9c3.9-1.2,7.9-2.2,11.9-3.1l0.6,2.9C310.6,48.3,306.7,49.3,302.8,50.5L302.8,50.5z M386.2,47.6 c-3.9-0.9-7.9-1.6-11.8-2.2l0.4-3c4,0.6,8.1,1.4,12.1,2.3L386.2,47.6z M326.4,45.3l-0.4-3c4-0.6,8.1-1,12.2-1.3l0.2,3 C334.3,44.3,330.3,44.7,326.4,45.3L326.4,45.3z M362.3,44.1c-4-0.3-8-0.5-12-0.5v-3c4.1,0,8.2,0.2,12.3,0.5L362.3,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.6,311.6l-2.3-1.9c1.2-1.5,2.5-3.1,3.6-4.7l2.4,1.8C483.1,308.5,481.9,310.1,480.6,311.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.2,318.8c-1.1-1.7-2.2-3.4-3.3-5.1l2.5-1.6c1,1.7,2.1,3.4,3.2,5L181.2,318.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M527.2,304.9l-2.6-1.5c1.9-3.5,3.7-7,5.4-10.6l2.7,1.3C531,297.7,529.1,301.3,527.2,304.9z M171.9,303.2 c-1.9-3.6-3.7-7.2-5.4-10.8l2.7-1.3c1.7,3.6,3.5,7.2,5.3,10.7L171.9,303.2z M537.6,283l-2.8-1.1c1.5-3.7,2.9-7.4,4.1-11.2l2.8,1 C540.5,275.4,539.1,279.3,537.6,283z M161.7,281.3c-1.5-3.8-2.8-7.6-4.1-11.4l2.8-0.9c1.2,3.8,2.6,7.6,4,11.2L161.7,281.3z  M545.2,260l-2.9-0.8c1-3.8,2-7.7,2.7-11.6l2.9,0.6C547.2,252.2,546.3,256.1,545.2,260z M154.3,258.2c-1-3.9-1.9-7.9-2.7-11.8 l2.9-0.6c0.8,3.9,1.6,7.8,2.6,11.6L154.3,258.2z M550.1,236.3l-3-0.4c0.6-3.9,1-7.9,1.3-11.9l3,0.2 C551.1,228.2,550.6,232.3,550.1,236.3z M149.7,234.4c-0.5-4-0.9-8-1.2-12l3-0.2c0.3,4,0.7,8,1.2,11.9L149.7,234.4z M552,212.1 l-3-0.1c0-1.5,0-3,0-4.5c0-2.5,0-5-0.1-7.5l3-0.1c0.1,2.5,0.1,5.1,0.1,7.6C552.1,209.1,552.1,210.6,552,212.1z M147.9,210.3 c0-0.9,0-1.8,0-2.7c0-3.1,0.1-6.3,0.2-9.4l3,0.1c-0.1,3.1-0.2,6.2-0.2,9.3c0,0.9,0,1.8,0,2.6L147.9,210.3z M548.2,188.2 c-0.4-4-0.9-7.9-1.5-11.8l3-0.5c0.6,4,1.1,8,1.5,12L548.2,188.2z M152,186.4l-3-0.3c0.4-4,1-8,1.6-12l3,0.5 C153,178.5,152.4,182.5,152,186.4z M544.4,164.6c-0.8-3.9-1.8-7.8-2.9-11.6l2.9-0.8c1.1,3.9,2.1,7.8,3,11.8L544.4,164.6z  M155.9,162.9l-2.9-0.7c0.9-3.9,1.9-7.9,3.1-11.7l2.9,0.8C157.9,155.1,156.8,159,155.9,162.9L155.9,162.9z M537.9,141.7 c-1.3-3.7-2.8-7.5-4.3-11.1l2.8-1.2c1.5,3.7,3,7.5,4.3,11.3L537.9,141.7z M162.7,140l-2.8-1c1.4-3.8,2.9-7.6,4.5-11.3l2.8,1.2 C165.5,132.5,164,136.3,162.7,140z M528.7,119.8c-1.8-3.5-3.6-7.1-5.6-10.5l2.6-1.5c2,3.5,3.9,7.1,5.7,10.7L528.7,119.8z  M172.1,118l-2.7-1.4c1.8-3.6,3.8-7.2,5.8-10.7l2.6,1.5C175.8,111,173.9,114.5,172.1,118z M516.9,99c-2.2-3.3-4.5-6.6-6.8-9.8 l2.4-1.8c2.4,3.2,4.7,6.6,6.9,9.9L516.9,99z M184.2,97.4l-2.5-1.7c2.2-3.4,4.6-6.7,7-9.9l2.4,1.8C188.7,90.8,186.4,94.1,184.2,97.4 z M502.7,79.9c-2.5-3-5.2-6-7.9-8.9l2.2-2.1c2.8,2.9,5.5,6,8,9L502.7,79.9z M198.6,78.4l-2.3-2c2.6-3.1,5.4-6.1,8.1-9l2.2,2.1 C203.8,72.4,201.1,75.3,198.6,78.4L198.6,78.4z M486.3,62.5c-2.9-2.7-5.9-5.4-8.9-7.9l1.9-2.3c3.1,2.6,6.1,5.3,9.1,8L486.3,62.5z  M215.1,61.2l-2-2.2c3-2.7,6-5.4,9.1-7.9l1.9,2.3C221,55.9,218,58.5,215.1,61.2z M468,47.2c-3.2-2.4-6.5-4.6-9.8-6.8l1.6-2.5 c3.4,2.2,6.7,4.5,10,6.9L468,47.2z M233.6,46.1l-1.8-2.4c3.3-2.4,6.6-4.6,10-6.8l1.6,2.5C240.1,41.5,236.8,43.8,233.6,46.1z  M448,34.2c-3.5-2-7-3.8-10.6-5.6l1.3-2.7c3.6,1.8,7.2,3.7,10.7,5.7L448,34.2z M253.7,33.3l-1.5-2.6c3.5-1.9,7.1-3.8,10.8-5.5 l1.3,2.7C260.7,29.5,257.2,31.4,253.7,33.3L253.7,33.3z M426.5,23.7c-3.7-1.5-7.4-3-11.2-4.3l1-2.8c3.8,1.3,7.6,2.8,11.3,4.3 L426.5,23.7z M275.2,23l-1.1-2.8c3.7-1.5,7.6-2.9,11.4-4.2l1,2.8C282.6,20.1,278.9,21.5,275.2,23z M404,15.9 c-3.8-1.1-7.7-2-11.6-2.9l0.6-2.9c3.9,0.9,7.9,1.8,11.8,2.9L404,15.9z M297.9,15.4l-0.8-2.9c3.9-1,7.9-2,11.8-2.8l0.6,2.9 C305.5,13.4,301.6,14.4,297.9,15.4L297.9,15.4z M380.7,10.8c-3.9-0.6-7.9-1.1-11.8-1.5l0.3-3c4,0.4,8.1,0.9,12,1.5L380.7,10.8z  M321.2,10.6l-0.4-3c4-0.6,8-1,12-1.4l0.3,3C329.1,9.5,325.1,10,321.2,10.6L321.2,10.6z M356.9,8.6c-4-0.1-8-0.1-11.9,0l-0.1-3 c4-0.1,8.1-0.1,12.1,0L356.9,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M517.6,320.6l-2.5-1.7c1.1-1.6,2.2-3.3,3.3-5l2.5,1.6C519.8,317.2,518.7,318.9,517.6,320.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.5,193.7l-5.2,2.6c-0.9,0.5-1.9,0.7-3,0.7c-2.4,0-4.5-1.4-5.6-3.5l-1.7-3.5l5.2-2.6l2.2-1.1 c1.9-1,4.3-0.2,5.2,1.8L351.5,193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.3,190.6l-1.8,3.5c-0.6,1.2-1.6,2.2-2.9,2.8c-2.4,0-4.7-1.4-5.8-3.5l-1.8-3.5l5.4-2.6L348.3,190.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "383.6,127.9 373.9,168.3 382.4,176.9 386.1,164.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M331.8,176.1c0,24.5-2,43.5-2,43.5h-8.9v-89l4.4,1C329.6,146.1,331.8,161,331.8,176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M321.2,222.5v13.1c0,0,12.1-0.8,6.9-13.1H321.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.9,
    y: 219.6,
    className: "st8",
    width: 8.2,
    height: 2.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "645.8,125.1 638.9,215.8 669.2,215.8 671.7,117.9 651.9,117.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "651,126.8 655.9,132.1 662.2,127 657.2,120.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "655,123.3 653.8,129.9 647,195.6 652.8,202.8 658.5,196 658.3,130.4 658.6,123.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "625.7,182.1 638.8,180.9 635,127.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.3,
    y: 172,
    className: "st10",
    width: 15.3,
    height: 16.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.7,
    y: 157,
    className: "st11",
    width: 38.9,
    height: 27.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "657.2,205.2 677,318.7 686.1,318.7 685.7,205.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "640.2,314.8 651.3,314.8 664.6,205.2 638.9,205.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M681.4,315c-2.6,0-4.7,2.1-4.7,4.7v3.5h9.4v-3.5C686.1,317.1,684,315,681.4,315z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.4,
    y: 269.5,
    transform: "matrix(1.517975e-02 -0.9999 0.9999 1.517975e-02 364.4523 910.2079)",
    className: "st14",
    width: 89.8,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676.6,
    y: 232.9,
    transform: "matrix(0.995 -0.1001 0.1001 0.995 -24.0371 69.1959)",
    className: "st14",
    width: 1.2,
    height: 82.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "656,217.6 655.3,218.5 659.6,221.8 660.9,228.8 662.1,228.6 660.7,221.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M686.8,128.2l0.9,92.3h9.9c0,0,1.3-24.2,2.3-45.2c0.1-2.3,0.2-4.5,0.2-6.7c-0.2-13.9-3.2-27.7-8.8-40.4H686.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M687.7,220.5v12.9c0,0,13-0.8,7.5-12.9L687.7,220.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M667.4,139.4c-2,20.8-3.5,81.8-3.5,81.8h21.9l3-62.2l2.4-30.7L671.6,118C671.3,118.5,668.9,123.4,667.4,139.4 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "651.9,117.5 659.9,117.9 660.3,117.9 671.5,117.9 670.7,117.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M635,127.4l-1.1,93.7H644c0,0-3.2-87.7,7.9-103.7L635,127.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "671.6,118 671.6,117.9 671.5,117.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M651.9,92.7l-0.4,27.8c0,0,1.3,1.3,8.6,1.3c4.2,0.1,8.3-1.3,11.6-3.9l-3.4-22.5L651.9,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M651.5,119.9c15.8,0,15.8-10.8,15.8-10.8h-15.8L651.5,119.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.7,
    y: 150,
    className: "st14",
    width: 5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M664.6,77.6h-7.2c-6.8,0-12.2,5.5-12.2,12.3v0v12.5h25.4c2.6,0,4.7-2.2,4.7-4.8v0v-9.2 C675.3,82.5,670.5,77.6,664.6,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M659,82.1h-3.9c-8.3,0-9.9,7.7-9.9,10.4v22.7c13.9,7.9,22.1-3.3,22.1-3.3V92.2C667.3,92.2,668.4,82.1,659,82.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M656.8,108c0,0-0.9,4.5-4.8,4.5s-4.8-4.5-4.8-4.5H656.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M668.6,82.1c-2.2,0-4,1.8-4,4v7.3c0,5,4,9,9,9V87.2C673.6,84.4,671.4,82.1,668.6,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M671,97c-1.5,0-2.8,1.2-2.8,2.8v8.3h2.8c1.5,0,2.7-1.2,2.7-2.7v-5.6C673.7,98.2,672.5,97,671,97z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "650.8,104.4 651.1,101.9 649.9,101.8 649.5,105.6 652.1,105.6 652.1,104.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M650.3,77.6c-4.1,4-0.5,9.5,3.7,8.3c4.2-1.2,12.6-7.8,12.6-7.8S654.4,73.6,650.3,77.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.3,
    y: 145.3,
    transform: "matrix(1 -2.001597e-03 2.001597e-03 1 -0.3395 1.3752)",
    className: "st14",
    width: 1.2,
    height: 50.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.2,
    y: 146.9,
    transform: "matrix(0.9356 -0.353 0.353 0.9356 -9.8884 251.5533)",
    className: "st14",
    width: 1.2,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.6,
    y: 172.6,
    transform: "matrix(0.9268 -0.3756 0.3756 0.9268 -14.582 271.673)",
    className: "st14",
    width: 6,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.3,
    y: 175.1,
    transform: "matrix(0.9908 -0.1355 0.1355 0.9908 -17.4353 95.2551)",
    className: "st14",
    width: 7.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "673.1,195.5 673.1,191.4 671.9,191.4 671.9,196.7 684.4,196.7 684.4,195.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M623.2,178.9h3c2.8,0,5.1,2.3,5.1,5.1v0.2c0,2.8-2.3,5.1-5.1,5.1h-3c-2.8,0-5.1-2.3-5.1-5.1V184 C618.1,181.2,620.4,178.9,623.2,178.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.6,
    y: 164.2,
    transform: "matrix(3.052793e-02 -0.9995 0.9995 3.052793e-02 450.9091 794.4272)",
    className: "st14",
    width: 46.8,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "680.5,133.6 672.5,118.9 671.5,119.5 678.9,133.3 670.2,140.3 678.9,145.7 667.2,166.7 668.2,167.3  680.5,145.3 672.3,140.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "647.9,121.5 639.9,134.9 642.7,138.4 638.2,141.1 642.5,164.1 643.7,163.8 639.5,141.7 644.5,138.8  641.4,134.8 649,122.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "637.6,191.5 637.6,195.5 634.5,195.5 634.5,196.7 638.8,196.7 638.8,191.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M631.5,323.2h18.9l0.8-8.4h-11.1C635.5,314.8,631.6,318.5,631.5,323.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M7.5,168.7c-0.3,2.1-0.5,4.2-0.8,6.4c-2.1,20.1-2,45.2-2,45.2l5.5,0.8l12.3-89.5l-3.2-0.4 C13.4,143,9.4,155.6,7.5,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M8.6,218.8l1.9,0.3l-0.8,6c-0.6,4.6-4.9,7.8-9.5,7.2l-0.2,0l1.1-7.7C1.6,220.9,4.9,218.3,8.6,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.4,188.1l12.7,2.2l8.3-52l-7.5-6.6C17.8,131.7,7.5,155.3,4.4,188.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 177,
    transform: "matrix(0.1045 -0.9945 0.9945 0.1045 -174.4577 176.6662)",
    className: "st1",
    width: 11.3,
    height: 16.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "22.6,202.4 30.4,314.5 40.5,314.5 48.3,202.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "67,202.4 64.6,314.5 54.5,314.5 43.6,202.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.8,
    y: 224.1,
    transform: "matrix(0.9999 -1.489901e-02 1.489901e-02 0.9999 -4.0056 0.9447)",
    className: "st19",
    width: 1.2,
    height: 90.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M73.6,322.8c0-4.6-3.7-8.4-8.4-8.4H54.6v8.4H73.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M21.5,322.8h19v-8.4H29.8C25.2,314.5,21.5,318.2,21.5,322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M79.1,170.5c0,2.1,0,4.3-0.1,6.5c-0.7,20.2-4.1,45-4.1,45h-5.5v-90.3h3.2C76.8,144.2,79,157.3,79.1,170.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,189.1H69.3v-57.4h3.2C72.5,131.7,83.1,142.5,80,189.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.8,
    y: 177.8,
    className: "st1",
    width: 12.8,
    height: 11.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9,
    y: 228.1,
    className: "st13",
    width: 27.1,
    height: 38.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4,
    y: 229.4,
    className: "st8",
    width: 24.2,
    height: 34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.4,
    y: 226.4,
    className: "st21",
    width: 14.3,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M59.3,98.1L59.3,98.1v11.3c1.5,0,2.8-1.2,2.8-2.8v-5.7C62.1,99.4,60.8,98.1,59.3,98.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67,212.5 23.3,212.5 17.8,131.7 36,124.5 54.3,124.5 72.5,131.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M55.2,125c0,0-2.6,2.4-10.1,2.4c-7.4,0-10.1-2.4-10.1-2.4v-15.3h20.1V125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M55.2,122.6v-9.2H38.6C38.6,113.4,41.6,121.7,55.2,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M34.5,93.9v5.5h0.6V114c4.8,3.6,10.7,5.3,16.7,4.8c4.9-0.5,8.6-4.6,8.6-9.6V93.9c0-7-5.7-12.7-12.6-12.7h0 h-0.6C40.2,81.3,34.5,86.9,34.5,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M59.3,88.8c-2-4.5-6.6-7.5-11.5-7.5h-0.6c-7,0-12.6,5.7-12.6,12.7v5.5h0.6v2.8h4.2v-6.4h1.5 c1.9,0,3.5-1.5,3.5-3.4c0-2,1.6-3.6,3.6-3.6L59.3,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M34.2,98.1L34.2,98.1c-1.5,0-2.8,1.2-2.8,2.8v5.7c0,1.5,1.2,2.8,2.8,2.8H37V101C37,99.4,35.7,98.1,34.2,98.1 L34.2,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M53.4,106.6v-1.2c0.7,0,1.3-0.6,1.3-1.3l0,0l-0.1-2h1.2l0.1,2C55.9,105.5,54.9,106.6,53.4,106.6L53.4,106.6 L53.4,106.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.4,
    y: 164.4,
    transform: "matrix(6.522366e-02 -0.9979 0.9979 6.522366e-02 -98.9962 224.2755)",
    className: "st24",
    width: 25.7,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "47.1,231.6 46,231.5 46.8,224.6 52,223.2 52.3,224.4 47.8,225.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.3,110.2h-9.9c0,0,1.8,3.7,5.2,3.7S57.3,110.2,57.3,110.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "45.2,140.3 50.4,135.7 45.2,128.9 40,135.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "51.6,204.3 45.2,211.5 38.8,204.3 43.4,131.9 46.9,131.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "52.4,139.8 45.2,130.1 38,139.8 30.2,131.8 31,131 37.8,138 45.2,128.2 52.5,138 59.3,131  60.2,131.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7,
    y: 225.6,
    transform: "matrix(0.9995 -3.310813e-02 3.310813e-02 0.9995 -8.924 1.2159)",
    className: "st19",
    width: 1.2,
    height: 88.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M77.9,234.5h-0.2c-4.6,0-8.4-3.8-8.4-8.4v-6.1h1.9c3.7,0,6.7,3,6.7,6.7L77.9,234.5L77.9,234.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M506.8,162.1h-26.1V101c0-7,5.7-12.8,12.8-12.8h0h0.6c7,0,12.8,5.7,12.8,12.8L506.8,162.1L506.8,162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M480.1,265c1.4,16.8,4.5,33.4,9.2,49.5h8.2c0,0-1.8-23.9-0.9-49.5c0.2-6.6,0.7-13.3,1.3-19.8 c0.2-2,0.5-4,0.7-6c1.7-12.3,5.3-24.3,10.5-35.7h-23.3c0,0-4.9,11-6.2,43.1C479.5,252.8,479.6,258.9,480.1,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M496.2,203.5l1.8,41.7l0.8,19.8l2.1,49.5h9.4c0,0,3.5-29.7,6.3-49.5l0.2-1.3c3.1-22.3,3.9-43.5,1.3-54.7 c-0.4-1.9-1.1-3.7-2-5.5L496.2,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478.9,176.5c-0.8,11.7,0.2,34.4,0.2,34.4l4.4,0.3l4.8-68.4l-3.4-0.2C484.8,142.6,479.7,164.9,478.9,176.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M483.4,211.2l-1,14.3c0,0-8.3-4.2-3.3-14.6L483.4,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M480.1,265h36.5l0.2-1.3c3.1-22.3,3.9-43.5,1.3-54.7l-1.5-5.7l-30.6,0.2c0,0-4.9,11-6.2,43.1 C479.5,252.7,479.6,258.9,480.1,265z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M478.6,322.9c0-4.6,3.7-8.4,8.4-8.4h10.5l-1.5,8.4H478.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M502.9,137.8h-0.4V110h19.1v9.1C521.6,129.4,513.3,137.8,502.9,137.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.6,
    y: 111.3,
    transform: "matrix(0.8544 -0.5196 0.5196 0.8544 13.7274 273.9308)",
    className: "st26",
    width: 0.3,
    height: 2.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "484.3,208.4 488.4,209.7 493.3,203.5 502,210.6 518.7,203.9 515.7,186.2 521.6,169.7 524.4,141.8  512.2,138.1 497.9,137.4 484.8,142.6 487,187.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.2,
    y: 183.2,
    transform: "matrix(0.605 -0.7962 0.7962 0.605 51.9947 480.9752)",
    className: "st27",
    width: 1.2,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.1,
    y: 181,
    transform: "matrix(0.7905 -0.6125 0.6125 0.7905 -6.0169 352.8555)",
    className: "st27",
    width: 1.2,
    height: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M487.8,151.6l4.3-2.7l-3.3-1.6l16.7-14.8l11,16l-6,1.4l5,3.9l-20.2,15.4L487.8,151.6z M507.8,149.4l6.8-1.5 l-9.3-13.5L491,147.1l3.6,1.7l-5.3,3.3l6.5,15.4l17.8-13.6L507.8,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M512.1,138.1c0,0-3.4,13.2-16.6,30.3c-4.2-15.5,2.4-31,2.4-31L512.1,138.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "512.1,138.1 516.7,145.2 490.1,145.2 497.9,137.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M497.9,138.1c0,0-0.4,2.4,4.8,2.4c3.3,0,6.5-0.9,9.4-2.4v-15.2h-14.2V138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M497.9,136v-9.5h12.9C510.8,126.5,508.5,135.1,497.9,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M514.8,108.6v8.1h-2.7V128c0,0-8.9,7.8-17.2,3.9c-3.6-1.8-5.9-5.5-5.9-9.5v-13.8c0-2.3,0.6-4.5,1.7-6.5 c2.2-4,6.4-6.6,11-6.6h0.5C509.3,95.7,514.9,101.6,514.8,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M521.6,107.8v7.4c-1.9,0.4-3.8,0.5-5.8,0.4c-2.9,0.8-6-0.4-7.7-2.9l0.1-3.7c0-5.5-8,1-7.7-7.7h-9.8 c2.1-4.9,5.5-8.4,15.4-8.4c8.2-0.3,15.2,6.2,15.4,14.4C521.6,107.5,521.6,107.6,521.6,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M512.8,121.8h-2.6v-7.4c0-1.4,1.1-2.5,2.5-2.5h0.1c1.4,0,2.5,1.1,2.5,2.5v5 C515.3,120.7,514.2,121.8,512.8,121.8L512.8,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M494.6,120.5v-1.2c-1.2,0-2.2-1-2.2-2.2v-0.3h-1.2v0.3C491.3,119,492.8,120.5,494.6,120.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "494,194.5 502.2,210.6 493.3,203.5 488.4,209.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "512.1,138.1 500.2,147.2 497.9,138.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "501.9,211.3 515.8,206.2 515.4,205.1 502.5,209.9 493.7,192.6 488,208.9 484.4,207.8 484.1,208.9  488.7,210.4 493.9,195.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "493.9,195.5 494.9,195 492.5,190.4 492.5,173.4 496,168.8 495,168.1 491.3,173 491.3,190.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "502.4,148.4 506.4,145.8 516.7,145.8 516.7,144.6 506,144.6 501.8,147.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "497.7,147.4 498.8,147 497.9,144.6 490.1,144.6 490.1,145.8 497.1,145.8  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 496.2,
    cy: 178.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st27",
    cx: 496.4,
    cy: 188.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M524.4,141.8c4.4,15.8,7.1,32,8,48.4L524,191l-6.9-43L524.4,141.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.1,
    y: 157.4,
    transform: "matrix(0.9874 -0.1585 0.1585 0.9874 -19.3594 84.4269)",
    className: "st27",
    width: 1.2,
    height: 12.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 175.8,
    className: "st11",
    width: 38.1,
    height: 25.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.3,
    y: 159.5,
    transform: "matrix(0.4863 -0.8738 0.8738 0.4863 127.5294 537.0894)",
    className: "st27",
    width: 4.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M491.4,322.9c0-4.6,3.7-8.4,8.4-8.4h10.5v8.4H491.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M494.8,128.1c5.2,0,4.6-3.9,4.6-3.9h-4.6V128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M188.2,273.4h-45.8v-24.1c0-1.2,1-2.2,2.2-2.2h36.8c3.8,0,6.9,3.1,6.9,6.9V273.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M182,257h-33.4c-3.4,0-6.2-2.8-6.2-6.2v-5.2c0-3.4,2.8-6.2,6.2-6.2H182c3.4,0,6.2,2.8,6.2,6.2v5.2 C188.2,254.2,185.4,257,182,257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M157.2,239.4h1.8v-2c0-1.2,0.7-2.1,1.6-2.1h9.3c0.9,0,1.6,1,1.6,2.1v2h1.8v-2c0.1-2-1.4-3.8-3.4-3.9h-9.3 c-2,0.1-3.6,1.9-3.4,3.9L157.2,239.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 220.4,
    className: "st8",
    width: 12.1,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.5,226.2h12.1v4c0,3-2.4,5.4-5.4,5.4H164c-3,0-5.4-2.4-5.4-5.4L158.5,226.2L158.5,226.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M171.2,178.8c0,21,0.3,42.4,0.3,42.4h-9.7l0.2-89.5h4.1C166,131.7,171.2,149.6,171.2,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M142,87.5h3c5.3,0,9.7,4.3,9.7,9.7v4.1H142V87.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "117.3,215.4 117,318 125.7,318 144.7,215.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "162.4,215.4 161,314.5 150.4,314.5 137.6,215.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "166,131.7 149.8,124.5 131.7,124.5 112,130.1 114.3,164.4 119.7,184.8 117.3,211.6 117.3,221.5  162.4,215.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "147.7,168 125.2,148 133.7,144.5 123.9,139.2 131.6,124.6 132.6,125.2 125.5,138.7 136.4,144.6  127.4,148.4 147.3,166.1 157,146.2 150.1,144.2 157.5,139.2 146.8,122.9 147.8,122.3 159.1,139.5 152.9,143.8 158.6,145.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "158.9,221.8 142.5,213.2 143.2,174.1 147.1,166.5 148.1,167.1 144.4,174.4 143.7,212.5 159.5,220.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "130.8,124.9 141.7,151.7 147.3,165.7 148.1,152.5 149.8,124.9 142.1,124.9 141.8,124.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "143.3,136.8 147,131.6 142,125.7 137.3,131.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "140.6,127.9 140.9,134.3 141.7,151.7 147.3,165.7 148.1,152.5 144.9,133.9 143.9,127.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.8,124.9c0,0-2.5,3.8-9.5,3.8s-9.5-3.8-9.5-3.8v-24.3h19V124.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.8,124.2v-11.7h-15.7C134.1,112.5,134.1,124.2,149.8,124.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M161.1,314.5h-10.7l1.6,8.4h17.4C169.5,318.2,165.7,314.5,161.1,314.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M121.4,314.5h0.2c2.4,0,4.4,2,4.4,4.4v4h-9v-4C117,316.5,118.9,314.5,121.4,314.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M153.6,99.9L153.6,99.9v10.6c1.4,0,2.6-1.2,2.6-2.6v-5.4C156.3,101.1,155.1,99.9,153.6,99.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M154.6,120.1c-7.5,2.8-15.9,0.8-21.3-5.1V93.8c-0.1-2.4,1.7-4.5,4.1-4.6h7.6c8,0,9.5,6.6,9.5,11.2L154.6,120.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M133.4,85.6L133.4,85.6c-3.4,0-6.1,2.7-6.1,6.1v13.4h10.9V90.4C138.1,87.8,136,85.6,133.4,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.9,99.9L129.9,99.9c-1.4,0-2.6,1.2-2.6,2.6v5.4c0,1.4,1.2,2.6,2.6,2.6h2.6v-8 C132.5,101.2,131.4,100,129.9,99.9L129.9,99.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "150.5,109.4 148,109.4 148,108.3 149.3,108.3 149,105.9 150.1,105.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M134.3,219l-0.5-0.5c-2.9-3.3-7-5.3-11.3-5.5v-1.2c4.5,0.3,8.6,2.2,11.7,5.4l8.4-10.5l0.9,0.7L134.3,219z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 149.1,
    cy: 184.9,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M149.1,197.9c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6 C147.5,198.6,148.2,197.9,149.1,197.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M141,112.4h9.9v3.9C150.9,116.3,144.5,117.5,141,112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.3,95.2L140.3,95.2c-2.8,0-5.2,2.3-5.2,5.2v6.7h5.2V95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M142.1,81.9h12.7v0.2c0,6-4.8,10.8-10.8,10.8h0h-12.7v-0.2C131.3,86.8,136.1,82,142.1,81.9L142.1,81.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 228.1,
    transform: "matrix(0.9999 -1.489901e-02 1.489901e-02 0.9999 -4.0246 2.3712)",
    className: "st30",
    width: 1.2,
    height: 86.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.8,
    y: 274.5,
    transform: "matrix(9.983826e-02 -0.995 0.995 9.983826e-02 -160.8166 372.451)",
    className: "st30",
    width: 79.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.1,
    y: 183.2,
    transform: "matrix(4.414189e-02 -0.999 0.999 4.414189e-02 -27.2031 339.1743)",
    className: "st30",
    width: 77.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.5,
    y: 215.3,
    transform: "matrix(0.8451 -0.5347 0.5347 0.8451 -98.0099 98.2466)",
    className: "st8",
    width: 12.1,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M124.9,227.4l-3.3,2.1l-3.9-6.1l9.4-6C129.3,220.8,128.3,225.3,124.9,227.4L124.9,227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M124,212.5l-14.3-32.3l6.9-14.7l-4.6-35.3c-10.2,17-18.1,52.3-18.1,52.3l18,37.7L124,212.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.9,
    y: 201.5,
    transform: "matrix(0.8431 -0.5378 0.5378 0.8431 -88.9221 99.3623)",
    className: "st30",
    width: 11.9,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 197.8,
    transform: "matrix(0.553 -0.8332 0.8332 0.553 -109.3544 192.9224)",
    className: "st30",
    width: 15.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "124,194.4 123,193.8 127.1,187.4 119.9,185.7 120.2,184.6 129,186.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "115.7,168.8 114.7,168.3 119.4,159.1 114.6,142.8 115.8,142.5 120.7,159.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M120.7,230.6l-0.4-1.1c0.1,0,5.6-2.1,6.8-5.5c0.7-2.5,0.9-5.1,0.6-7.6l1.2-0.2c0.4,2.7,0.2,5.5-0.6,8.2 C126.9,228.4,121,230.5,120.7,230.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 199,
    transform: "matrix(0.9038 -0.4279 0.4279 0.9038 -78.2225 73.1161)",
    className: "st30",
    width: 1.2,
    height: 23.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 180.1,
    transform: "matrix(0.9884 -0.1521 0.1521 0.9884 -26.2648 18.038)",
    className: "st30",
    width: 8.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 173,
    transform: "matrix(0.4188 -0.9081 0.9081 0.4188 -100.4453 198.3421)",
    className: "st30",
    width: 1.2,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.9,
    y: 172.1,
    transform: "matrix(0.4369 -0.8995 0.8995 0.4369 -96.5242 195.0387)",
    className: "st30",
    width: 1.2,
    height: 5.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "141.4,236.6 140.2,236.4 141.5,229.2 146.1,225.8 146.8,226.7 142.6,229.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.8,
    y: 155.7,
    className: "st30",
    width: 6.8,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.9,
    y: 182.7,
    transform: "matrix(0.7601 -0.6497 0.6497 0.7601 -79.275 151.7463)",
    className: "st30",
    width: 5.9,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "325.3,131.8 310.1,124.5 291.8,124.5 275.9,131.8 277.3,215.5 322.4,215.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 144.6,
    className: "st32",
    width: 1,
    height: 69.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "308.7,168 320.3,145.6 314.2,143.8 320.9,139.6 308.8,122.3 307.9,123 319.2,139.3 311.4,144.2  318.6,146.3 308.4,166.2 287.3,148.5 296.8,144.7 285.2,138.7 292.7,125.2 291.7,124.7 283.6,139.2 294,144.5 285,148.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "308.2,212.8 313,209.7 313.7,170.6 308.9,166.7 308.2,167.6 312.5,171.2 311.9,209 307.5,211.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "290.9,124.9 302.4,151.8 308.3,165.7 309.2,152.6 311,125 302.9,124.9 302.5,124.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "303.9,136.1 308.5,130.9 302.6,124.7 298.3,132.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "301.3,127.9 301.6,134.4 302.4,151.8 308.3,165.7 309.2,152.6 305.9,133.9 304.7,127.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311,125c0,0-2.6,2.4-10.1,2.4s-10.1-2.4-10.1-2.4v-15.2H311V125z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "277.3,215.5 277,318.7 285.8,318.1 304.8,215.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "322.4,215.5 321.1,314.5 310.5,314.5 297.7,215.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M321.2,314.5h-10.7l1.6,8.4h17.4C329.5,318.3,325.8,314.5,321.2,314.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M281.5,314.5L281.5,314.5c-2.5,0-4.5,2-4.5,4.5v3.9h9V319C286,316.5,284,314.6,281.5,314.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 314,
    className: "st32",
    width: 9.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M284.7,316.7l1.1-0.5c0-0.1-1-2.3-4.3-2.3c-3.3,0-4.2,2.2-4.3,2.3l1.1,0.4c0-0.1,0.7-1.6,3.2-1.6 C284,315.1,284.7,316.7,284.7,316.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "320.7,224.8 321.5,224 307.9,211.6 289.8,222.9 280.1,222.9 280.1,224 290.1,224 307.8,213.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M308.3,185.2c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6 C306.7,185.9,307.4,185.2,308.3,185.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M307.9,197.5c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6 C306.3,198.2,307,197.5,307.9,197.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.4,
    y: 271.4,
    transform: "matrix(8.559000e-02 -0.9963 0.9963 8.559000e-02 -10.2189 532.8065)",
    className: "st32",
    width: 85.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.1,
    y: 230.2,
    transform: "matrix(0.9995 -3.144140e-02 3.144140e-02 0.9995 -8.4073 10.1244)",
    className: "st32",
    width: 1.2,
    height: 84.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.9,123.1v-12.5h-16.8C294.1,110.5,294.1,123.1,310.9,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.7,120.1v-12.7h-17.1C293.6,107.4,293.6,120.1,310.7,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M297.5,78.6h7.7c7.1,0,12.9,5.8,12.9,12.9l-0.5,13.9l-26.4-0.9c-2.8,0-5-2.2-5-5v-9.6 C286.2,83.7,291.3,78.6,297.5,78.6L297.5,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.7,120.7c-14.5,5.6-23.2-6.1-23.2-6.1V94c0,0-1.1-10.6,8.7-10.6h4.1c8.7,0,10.4,8,10.4,13.5L317.7,120.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.5,
    y: 110.7,
    className: "st8",
    width: 9.3,
    height: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M293.2,83.4L293.2,83.4c-2.9,0-5.3,2.4-5.3,5.3v15.9c5.2,0,9.5-4.2,9.5-9.5v-7.6 C297.4,85.2,295.5,83.4,293.2,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M290.8,98.9L290.8,98.9c-1.6,0-2.9,1.3-2.9,2.9v5.9c0,1.6,1.3,2.9,2.9,2.9h2.9v-8.7 C293.6,100.2,292.3,98.9,290.8,98.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "310.5,107.9 313.3,107.9 312.8,103.9 311.6,104 311.9,106.6 310.5,106.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M291.3,84.2c0,0,19.9-2,24.3,3.5c5.9,1.3,6.3-10.9,0.5-15c-2.4,2.8-12,2-16.9,2.8 C292.6,76.3,291.3,84.2,291.3,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M304.8,113.1h3.7c2.7,0,4.8-2.2,4.8-4.8h-3.7C307,108.3,304.9,110.5,304.8,113.1L304.8,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M317.9,113.1h-1.5c-2.6,0-4.7-2.1-4.7-4.7v-0.1h1.6c2.6,0,4.7,2.1,4.7,4.7V113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M296.3,95.5c0.2,4,1.1,7.8,2.5,11.5c2.4,6,9.1,5.1,9.1,5.1c0.3,1.9,2,3.3,4,3.3c3.4,0,4-3.1,4.2-3.4 c1.5-2,1.6-10.2,1.6-10.2l0.4,19.3c0,0-2,3.3-9.7,3.3c-12.5,0-15.8-7.6-15.8-7.6l1-16.4L296.3,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M296.3,93.3L296.3,93.3l-0.1-11.7h4.5v7.2C300.7,91.3,298.7,93.3,296.3,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M239.5,97h0.9c5.3,0,9.6,4.3,9.6,9.6v3.3c0,22-17.8,39.8-39.8,39.8h-0.9v-22.5C209.3,110.5,222.9,97,239.5,97 L239.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M245.9,194.2v16.2c0,0,8.9-1.5,3.8-13.8L245.9,194.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.7,196.6l-3.8-2.4l12.7-28.9l7.8,5C252.2,192.5,249.7,196.6,249.7,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.1,137c0,0,5.2,4.6,20.3,33.4l-8.1,3.4l-17.5-28.4L246.1,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.9,135.8c0,0-5,13.8-2.4,50.4c2.1,0.1,4.3,0.1,6.4-0.1l2-4.7l0.9-38.1L207.9,135.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M218.8,314.3h9.6c0,0,2.9-9.6,6.4-24.8c2.3-10.2,4.9-22.8,7-36.8c2.7-17.5,4.2-35.3,4.3-53h-21.7l-2.7,54.2 l-1.4,28.3L218.8,314.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M229,314.3c4.4,0,8,3.9,8,8.6h-18.7l0.6-8.6L229,314.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.1,199.6h-30.2c0,0,5.6-13-7.7-47.3l-0.3-16.5l11.7-3.8l13.6-0.7l12.9,5.7V199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M236.6,201.2h1.2v-42.5c0-9.5-2.9-18.7-8.3-26.5l-0.9,0.7c5.2,7.6,8,16.6,8,25.8L236.6,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M227.9,141.6l2.5-7.8l6,7.3l0.5-0.5c2-2,1-5.7,0.9-5.9l-1.1,0.3c0,0,0.7,2.5-0.2,4.2l-6.4-7.9l-2.6,8.2 l-6.2-5.6l-0.8,0.9L227.9,141.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.8,
    y: 176.6,
    transform: "matrix(0.7075 -0.7067 0.7067 0.7075 -63.1452 211.9039)",
    className: "st24",
    width: 1.2,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 184.9,
    transform: "matrix(0.7075 -0.7067 0.7067 0.7075 -67.5141 215.7144)",
    className: "st24",
    width: 1.2,
    height: 9.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M233.2,132c0,0,0.4,2.4-4.6,2.4c-3.1-0.1-6.2-0.9-8.9-2.4v-15.8h13.5L233.2,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M233.2,130.9v-7.2H221C221,123.7,221.9,130.9,233.2,130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M215.2,254.2c0.5,2.4,1.1,4.9,1.5,7.6c1.4,7.4,2.6,14.3,3.7,20.4c3.5,20,5.5,32.2,5.5,32.2h8.9V199.6h-18.9 C206,221.1,210.9,235.1,215.2,254.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M235.9,314.3c4.4,0,8,3.9,8,8.6h-16l-2.2-8.6H235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M215.2,254.2l6.6-0.4l13-0.8l7-0.4c2.7-17.5,4.2-35.3,4.3-53h-30.2C206,221.1,210.9,235.1,215.2,254.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.1,
    y: 210.3,
    transform: "matrix(0.3702 -0.9289 0.9289 0.3702 -80.9583 339.3121)",
    className: "st38",
    width: 25.4,
    height: 38.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M212.9,212.9l-6.1,12.7c0,0-11.3-3.9,1.7-12.2L212.9,212.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M208.4,213.4l4.5-0.5l1.1-31.5c-5.1,0.6-9.1-0.9-8.5,4.2C207.7,203.7,208.4,213.4,208.4,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M216.1,110.7h3.6v9h-0.1c-1.9,0-3.5-1.6-3.5-3.5V110.7L216.1,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M217.3,103.3v8.5h2.4v11.8c0,0,7.8,8.2,15.1,4.1c3.2-1.8,5.2-5.8,5.2-10v-14.4c0-2.3-0.5-4.7-1.5-6.8 c-1.9-4.1-5.5-6.9-9.7-6.9h-0.4C222.3,89.6,217.3,95.8,217.3,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M235.8,117.4c0.6,0,1.1-0.3,1.5-0.8c0.4-0.6,0.6-1.3,0.5-2l-0.1-0.8l-1.1,0.2l0.1,0.8c0,0.4,0,0.7-0.3,1 c-0.2,0.2-0.4,0.3-0.7,0.4L235.8,117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M226.5,120.5c0,0,0.9,4.5,4.8,4.5s4.8-4.5,4.8-4.5H226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M242,104.5c0,0-18.9-1.7-32.7,22.4v-23c0.1-8.9,7.4-16.1,16.3-16c8.9-0.1,16.2,7.1,16.3,16V104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M209.4,130h11.5v13.4h-0.3c-6.2,0-11.2-5-11.2-11.2V130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M226.9,158.3L226.9,158.3c-6.4,0-11.6-5.2-11.6-11.6v-18.3h3.7c4.4,0,7.9,3.6,7.9,7.9V158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M584.9,114.4h0.3c7.7,0,13.9,6.2,13.9,13.9v15.1h-14.2V114.4L584.9,114.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M595.9,215.8v16.7c0,0,8.5-5.1,4.4-16.7H595.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M553.1,178.8c0,1.1,0.1,2.2,0.1,3.3c1.4,28.5,4.6,34.9,4.6,34.9h4.4v-74.1H559 C559,142.9,552.5,153.5,553.1,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M562.2,217v15.5c0,0-8.5-3.9-4.4-15.5H562.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M559,203.5c0,54.6,18.6,111,18.6,111h10.1l-5.9-111H559z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M577,314.5c-4.6,0-8.4,3.7-8.4,8.4h19.6l-0.6-8.3L577,314.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M559,203.5h31.7c0,0-4.7-22.6,7.9-37.9l0.5-23.9l-12.3-3.7l-14.3-0.7l-13.6,5.5V203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M586.8,138.1l-18.3,26c0,0-2.8-21.4,4.1-26.7L586.8,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M577.7,147.6l-1.4-8l-5.3,7l-0.3-0.5c-1.4-2.2-0.4-5.7-0.3-5.9l0.9,0.4c-0.4,1.4-0.5,2.8-0.1,4.2l5.7-7.5 l1.5,8.3l5.4-5.2l0.6,0.9L577.7,147.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M572.6,138.1c0,0-0.4,2.4,4.8,2.4c3.3,0,6.5-0.9,9.4-2.4v-15.2h-14.2V138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M572.6,136v-9.5h12.8C585.4,126.5,583.2,135.1,572.6,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M589.5,108.6v8.1h-2.7v11.2c0,0-8.8,7.8-17.2,3.9c-3.6-1.8-5.9-5.5-5.9-9.5v-13.7c0-2.3,0.6-4.5,1.7-6.5 c2.2-4,6.4-6.6,11-6.6h0.5C584,95.7,589.7,101.5,589.5,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M589.5,108.6v7.4c-1.5,0.4-3,0.5-4.5,0.4c0,0-8.6-1.5-13.6-5.9c-3.5-3.1-5.2-6-6-8.4c2.2-4,6.4-6.6,11-6.6 h0.5C584,95.7,589.6,101.5,589.5,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M590.8,203.5c11.8,23.5,3.6,37.7-0.9,60.1c-6.1,30.8-9.6,50.9-9.6,50.9h-9.4v-111L590.8,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M569.7,314.5c-4.6,0-8.4,3.7-8.4,8.4h16.7l2.3-8.4H569.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M587.5,121.8h-2.6v-7.4c0-1.4,1.1-2.5,2.5-2.5h0.1c1.4,0,2.5,1.1,2.5,2.5v5 C589.9,120.7,588.8,121.8,587.5,121.8L587.5,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M569.5,121.5h-2c-0.3,0-0.6-0.3-0.6-0.6l0-0.1l1.1-7.1l1.2,0.2l-1,6.4h1.3L569.5,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M573.3,127.3h-0.5l0.1-1.2c1.6,0.2,3-0.9,3.3-2.4l1.1,0.3C577,125.9,575.3,127.3,573.3,127.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "571.5,283.1 570.3,283.1 570.3,219.9 565.2,217.5 565.7,216.4 571.5,219.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "584.2,289.8 585.3,290 580.3,315.1 579.2,315.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.9,
    y: 313.9,
    className: "st41",
    width: 14.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M605,177.6c0,1.1-0.1,2.2-0.1,3.3c-1.4,28.5-4.6,34.9-4.6,34.9h-4.4V145c0-1.8,1.4-3.2,3.2-3.2 C599.1,141.8,605.7,152.3,605,177.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "568.5,193.1 573.3,203.5 564.8,203.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M567.3,168.2c-0.5,0.6-0.4,1.6,0.2,2.1c0.6,0.5,1.4,0.5,1.9,0c0.5-0.6,0.4-1.6-0.2-2.1 C568.7,167.7,567.9,167.7,567.3,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M567.3,177.7c-0.5,0.6-0.4,1.6,0.2,2.1c0.6,0.5,1.4,0.5,1.9,0c0.5-0.6,0.4-1.6-0.2-2.1 C568.7,177.3,567.9,177.3,567.3,177.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M567.3,187.3c-0.5,0.6-0.4,1.6,0.2,2.1c0.6,0.5,1.4,0.5,1.9,0c0.5-0.6,0.4-1.6-0.2-2.1 C568.7,186.8,567.9,186.8,567.3,187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M342.2,187l5.6,2.8l-0.1,0.2c-2.5,5-8.5,7-13.5,4.5l-2.5-1.2l1.7-3.3C335,186.7,338.9,185.4,342.2,187z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 187.2,
    transform: "matrix(0.4441 -0.896 0.896 0.4441 14.9457 402.3745)",
    className: "st8",
    width: 7.4,
    height: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.3,178.8c22.6,11.3,32.1,14.8,32.1,14.8l4.3-8.7l-27.9-14.7L295.3,178.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.5,
    y: 185.8,
    transform: "matrix(0.896 -0.4441 0.4441 0.896 -47.6241 175.8014)",
    className: "st8",
    width: 3.9,
    height: 7.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M382.4,176.9c-21.2,13.3-26.6,17.1-26.6,17.1l-4.3-8.7l22.4-17L382.4,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.8,170.2l-27.8-38.5c0,0-7.1,14.3,5,29.2s14.4,17.8,14.4,17.8L303.8,170.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "329.1,184.3 303.3,170.7 284,143.9 285,143.2 304.2,169.8 329.7,183.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "326.4,193.9 294.9,179.3 278.4,160.1 279.4,159.3 295.6,178.3 326.9,192.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "406.2,212.8 435,212.8 430.2,316.9 422.2,316.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st18",
    points: "423,234.1 427.2,316.9 425.9,316.9 421.7,234.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "387.5,212.8 413.7,212.8 402.4,314 391.7,314  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M391.2,314h11.3l-0.9,8.8h-19.2C382.3,318,386.3,314,391.2,314z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M426.2,314c2.6,0,4.8,2.1,4.8,4.8v4.1h-9.5v-4.1C421.4,316.1,423.6,314,426.2,314z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "393.1,226.2 394.3,226.2 394.6,314 393.4,314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "409.7,235.1 408.4,228 404,224.7 404.7,223.7 409.5,227.3 410.9,234.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M449.5,175.5c0,21.4-3.2,45.9-3.2,45.9h-10v-93.9h4.4C440.8,127.6,449.5,142.7,449.5,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M436.3,221.4v13.1c0,0,13.3-0.8,7.6-13.1H436.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.3,
    y: 221.4,
    className: "st8",
    width: 8.5,
    height: 2.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "383.6,127.9 400.8,116.7 419.9,116.7 440.8,127.6 434.2,180.9 435.2,219.2 412.9,219.2 401,212.8  392.8,219.2 382.5,219.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M420.8,117.1c0,0-1.8,3-3.4,13.7c-0.3,2.3-0.7,5-1,8.1c-2,21.2-3.6,80.2-3.6,80.2l-12-6.4l-8.2,6.4 c0,0-2.9-77.8,6.5-99.6c0.4-1,1-2,1.6-2.9l8.1,0.4L420.8,117.1L420.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M420.8,117.1c0,0-1.8,3-3.4,13.7l-7.1,13.5l-8,20.7l-3.2-45.4c0.4-1,1-2,1.6-2.9l8.1,0.4L420.8,117.1 L420.8,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M412.7,120.8l-3.9,5.5c0,0,3,4.6,2.7,7.5c-0.3,2.9-1.1,10.6-1.1,10.6l-8,20.7l-1.4-20.3c0,0,0.9-9.7,1.4-12.3 c0.5-2.6,3.9-6.2,3.9-6.2l-2.7-5.4L412.7,120.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.3,
    y: 149.7,
    className: "st18",
    width: 5.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "436.3,195.9 435.7,145 436.9,145 437,195.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.6,
    y: 146.6,
    transform: "matrix(0.9356 -0.3532 0.3532 0.9356 -25.9266 163.2054)",
    className: "st18",
    width: 1.2,
    height: 12.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "401.4,210.8 400.6,209.8 405.6,205.2 405.6,174 401.8,167 402.9,166.4 406.8,173.6 406.8,205.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M400.9,176.3c-0.6,0.6-0.6,1.6,0,2.3c0.6,0.6,1.6,0.6,2.3,0s0.6-1.6,0-2.3S401.5,175.7,400.9,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M400.9,186.4c-0.6,0.6-0.6,1.6,0,2.3c0.6,0.6,1.6,0.6,2.3,0s0.6-1.6,0-2.3S401.5,185.8,400.9,186.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M400.9,196.5c-0.6,0.6-0.6,1.6,0,2.3c0.6,0.6,1.6,0.6,2.3,0s0.6-1.6,0-2.3S401.5,195.9,400.9,196.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.1,
    y: 172.8,
    transform: "matrix(0.9269 -0.3753 0.3753 0.9269 -32.971 177.4471)",
    className: "st18",
    width: 6.1,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.7,
    y: 175.3,
    transform: "matrix(0.9908 -0.1355 0.1355 0.9908 -19.7744 61.3332)",
    className: "st18",
    width: 7.6,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "417.4,167.3 416.3,166.7 428.2,145.4 419.4,139.8 428.3,132.8 420.7,118.7 421.8,118.1 429.8,133.1  421.6,139.7 429.9,144.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "391.8,164.8 386.8,140.6 391.4,138 388.6,134.3 396.8,120.8 397.8,121.4 390.1,134.2 393.2,138.3  388.2,141.3 393,164.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M388.9,188.4c0.9,0,1.5,0.7,1.5,1.5c0,0.9-0.7,1.5-1.5,1.5c-0.9,0-1.6-0.7-1.6-1.5 C387.3,189.1,388,188.4,388.9,188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M388.9,178.3c0.9,0,1.5,0.7,1.5,1.5c0,0.9-0.7,1.6-1.5,1.6c-0.9,0-1.6-0.7-1.6-1.6 C387.3,179,388,178.3,388.9,178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M421.4,219.2h-8.5l0.4-13.7l-0.2,5.2c-0.1,4.5,3.4,8.3,8,8.5L421.4,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M388.1,219.2h4.7l-0.1-13.7l0.1,5.2C392.8,215.3,390.7,219.2,388.1,219.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M399.7,118.6c0,0,2.9,3.7,10.1,3.7c4.3,0,8.3-1.9,11.1-5.1l-1.4-23.3h-19.3L399.7,118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400.1,117.8v-11.9h16C416.1,105.9,416,117.8,400.1,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400.3,115v-12h16.3C416.5,103,416.5,115,400.3,115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M412.8,75.6h-7.3c-6.8,0-12.3,5.5-12.3,12.3l0.5,13.2l25-0.8c2.6,0,4.8-2.1,4.8-4.8v-9.2 C423.5,80.4,418.7,75.6,412.8,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M393.6,114.2c13.8,5.3,22-4.5,22-4.5V90.2c0,0,1-10.1-8.3-10.1h-3.9c-8.2,0-9.9,7.6-9.8,12.8V114.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 106.1,
    className: "st7",
    width: 8.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M416.9,80.1L416.9,80.1c2.8,0,5,2.2,5,5v15.1c-5,0-9-4-9-9V84C412.9,81.8,414.7,80.1,416.9,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M419.2,94.9L419.2,94.9c1.5,0,2.7,1.2,2.7,2.7v5.6c0,1.5-1.2,2.7-2.7,2.7h-2.7v-8.3 C416.5,96.1,417.7,94.9,419.2,94.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "399.7,103.4 397.1,103.4 397.5,99.6 398.7,99.7 398.4,102.2 399.7,102.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M414,91.6c-0.2,3.8-1,7.5-2.4,11c-2.3,5.7-8.7,4.9-8.7,4.9c-0.3,1.8-1.9,3.2-3.8,3.2c-3.3,0-3.8-3-4-3.2 c-1.5-1.9-1.5-9.7-1.5-9.7v16.5c0,0,1.5,4.9,8.8,4.9c11.9,0,14.1-7.3,14.1-7.3V96.3L414,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M397.7,81.2h2.9v2.6h-2.9c-5.3,0-9.6-3.6-9.6-8v-2.6C388.2,77.6,392.4,81.2,397.7,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M400.8,83.8h-2.9v-2.6h2.9c5.3,0,9.6,3.6,9.6,8v2.6C410.4,87.4,406.1,83.8,400.8,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M419.2,81.2v2.7h-21.7c-4.1,0-7.5-4.8-7.5-10.6V73h23.5C416.6,73,419.2,76.6,419.2,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M405.1,83.8c4.3,0,7.8,3.5,7.8,7.8v-7.8H405.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M405.8,108.3h-3.6c-2.5,0-4.5-2-4.5-4.5v-0.1h3.6c2.5,0,4.5,2,4.5,4.5V108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M397.9,103.8h1.5v0.1c0,2.5-2,4.5-4.5,4.5h-1.5v-0.1C393.4,105.8,395.4,103.8,397.9,103.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 142.7,
    className: "st18",
    width: 1.2,
    height: 29.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.4,186h2.6v2.4c0,1.2-1,2.2-2.2,2.2h-0.4V186z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M337.4,193l6.1,2c0.8,0.3,1.3,1.1,1,2l0,0.1c-0.3,0.8-1.1,1.3-2,1l-6.1-2c-0.8-0.3-1.3-1.1-1-2l0-0.1 C335.7,193.2,336.6,192.8,337.4,193z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.8,
    y: 186.9,
    className: "st8",
    width: 0.6,
    height: 2.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "531.8,189.6 531.8,189.3 533.2,187.4 531.8,187.4 531.8,186.9 533.9,186.9 533.9,187.2 532.5,189.2  533.9,189.2 533.9,189.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M540.4,192.8c-0.1,0.5-3.6,0.6-3.9,0.6c0.7-0.2,1.9-0.5,2.5-0.9c0.1-0.1,0.1-0.3-0.1-0.3 c-0.3-0.1-0.7-0.2-1-0.2c-0.2,0-0.3,0-0.5,0l-0.1,0.1c-0.6,0.6-1.3,1.1-2.1,1.3h0c-0.3,0.1-0.7,0.1-1.1,0.1c-0.2,0-0.3,0-0.5,0 l-0.1,0l-0.2,0l0.1,0l0.1,0c0.8-0.1,1.7-0.7,2.3-1.2c0.3-0.3,0.5-0.6,0.7-1c0.3-0.5,0.4-1.1,0.5-1.6l-0.1,0.3 c-0.3,0.6-0.9,1.1-1.5,1.4l-0.2,0.1c-0.2,0-0.4,0.1-0.6,0.1c0.4-0.1,0.7-0.3,1-0.6c0.2-0.2,0.4-0.5,0.5-0.8l0-0.1 c0.1-0.2,0.2-0.4,0.2-0.7v0l0-0.2c0-0.2,0-0.3-0.1-0.5l0-0.1l0.6-0.1l0.1,0l0.2-0.1l0.2,0l-0.1-0.2l-0.2,0l-0.1-0.1l-0.3-0.6 c-0.1-0.1,0-0.3,0.2-0.3h0.5l0.1,0.1l0.3,1l0.5-0.1l0-0.2c0.1-1-0.3-1.6-0.7-2.3c-0.2-0.3-0.3-0.6-0.5-0.9c0.1,0.1,0.3,0.3,0.4,0.4 c0.8,0.8,1.3,1.7,1.5,2.9c0,0.2,0,0.3,0.1,0.5c0,0.1,0,0.2,0,0.3c0,0.9-0.3,1.7-0.6,2.4c0.5,0.2,1,0.4,1.4,0.7 c0.3,0.3,0.4,0.4,0.6,0.6C540.4,192.5,540.4,192.6,540.4,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M533.1,179.1c0.5-0.1,2,3.1,2,3.4c-0.5-0.5-1.2-1.6-1.8-1.9c-0.1-0.1-0.3,0-0.2,0.2c0,0.4,0.1,0.7,0.2,1.1 c0,0.2,0.1,0.3,0.2,0.5l0.2,0.1c0.8,0.3,1.5,0.8,2,1.5l0,0c0.2,0.3,0.4,0.6,0.5,1c0.1,0.1,0.1,0.3,0.2,0.4l0,0.1l0.1,0.2l-0.1-0.1 l-0.1-0.1c-0.4-0.7-1.3-1.3-2-1.7c-0.4-0.1-0.8-0.2-1.2-0.3c-0.6-0.1-1.1,0-1.7,0.2c0.1,0,0.2,0,0.3,0c0.7,0.1,1.4,0.4,1.9,0.9 l0.2,0.2c0.1,0.1,0.2,0.3,0.3,0.5c-0.2-0.3-0.6-0.5-0.9-0.7c-0.3-0.1-0.6-0.2-0.9-0.2l-0.1,0c-0.2,0-0.5,0-0.7,0.1l0,0l-0.2,0.1 c-0.2,0.1-0.3,0.1-0.4,0.2l-0.1,0l-0.4-0.5l-0.1-0.1l-0.1-0.2l-0.1-0.1l-0.2,0.1l0.1,0.2l0,0.2l-0.5,0.5c-0.1,0.1-0.3,0.1-0.3-0.1 l-0.2-0.5l0-0.1l0.9-0.6l-0.3-0.4l-0.2,0.1c-1,0.3-1.4,0.9-1.9,1.5c-0.2,0.3-0.4,0.5-0.6,0.8c0.1-0.2,0.1-0.4,0.2-0.5 c0.5-1,1.1-1.9,2.1-2.5c0.1-0.1,0.3-0.2,0.5-0.2c0.1,0,0.2-0.1,0.3-0.1c0.8-0.3,1.7-0.4,2.5-0.4c0-0.5,0-1.1,0.2-1.5 c0.1-0.4,0.2-0.6,0.3-0.8C532.9,179.2,533,179.1,533.1,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M523.9,192.4c-0.3-0.3,1.6-3.3,1.8-3.5c-0.2,0.7-0.8,1.8-0.7,2.5c0,0.1,0.2,0.2,0.3,0.1 c0.3-0.2,0.6-0.4,0.8-0.7c0.1-0.1,0.2-0.3,0.3-0.4l0-0.2c-0.2-0.8-0.1-1.7,0.2-2.5l0,0c0.1-0.3,0.3-0.7,0.5-1 c0.1-0.1,0.2-0.3,0.3-0.4l0.1-0.1l0.2-0.2l-0.1,0.1l0,0.1c-0.4,0.7-0.5,1.8-0.4,2.6c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.5,0.6,1,1,1.4 l-0.1-0.2c-0.3-0.6-0.4-1.4-0.2-2.1l0.1-0.2c0.1-0.2,0.1-0.3,0.2-0.5c-0.1,0.4-0.2,0.8-0.1,1.2c0,0.3,0.1,0.6,0.3,0.9l0,0.1 c0.1,0.2,0.3,0.4,0.4,0.5l0,0l0.2,0.1c0.1,0.1,0.3,0.2,0.4,0.3l0,0l-0.2,0.6l0,0.1l-0.1,0.2l-0.1,0.2l0.2,0.1l0.1-0.2l0.2-0.1 l0.7,0.2c0.1,0,0.2,0.2,0.1,0.3l-0.3,0.4l-0.1,0l-1-0.4l-0.2,0.4l0.2,0.2c0.8,0.7,1.5,0.7,2.3,0.8c0.3,0.1,0.7,0.1,1,0.1 c-0.2,0-0.4,0.1-0.6,0.1c-1.1,0.1-2.2,0.1-3.2-0.5c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.7-0.5-1.2-1.2-1.6-1.9 c-0.4,0.2-0.9,0.5-1.4,0.7c-0.4,0.1-0.6,0.2-0.8,0.2C524.1,192.5,524,192.5,523.9,192.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.8,
    y: 169.9,
    className: "st8",
    width: 0.6,
    height: 2.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "617.8,172.6 617.8,172.3 619.2,170.3 617.8,170.3 617.8,169.9 619.9,169.9 619.9,170.2 618.5,172.1  619.9,172.1 619.9,172.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M626.4,175.8c-0.1,0.5-3.6,0.6-3.9,0.6c0.7-0.2,1.9-0.5,2.5-0.9c0.1-0.1,0.1-0.3-0.1-0.3 c-0.3-0.1-0.7-0.2-1-0.2c-0.2,0-0.3,0-0.5,0l-0.1,0.1c-0.6,0.6-1.3,1.1-2.1,1.3h0c-0.3,0.1-0.7,0.1-1.1,0.1c-0.2,0-0.3,0-0.5,0 l-0.1,0l-0.2,0l0.1,0l0.1,0c0.8-0.1,1.7-0.7,2.3-1.2c0.3-0.3,0.5-0.6,0.7-1c0.3-0.5,0.4-1.1,0.5-1.6l-0.1,0.3 c-0.3,0.6-0.9,1.1-1.5,1.4l-0.2,0.1c-0.2,0-0.4,0.1-0.6,0.1c0.4-0.1,0.7-0.3,1-0.6c0.2-0.2,0.4-0.5,0.5-0.8l0-0.1 c0.1-0.2,0.2-0.4,0.2-0.7v0l0-0.2c0-0.2,0-0.3-0.1-0.5l0-0.1l0.6-0.1l0.1,0l0.2-0.1l0.2,0l-0.1-0.2l-0.2,0l-0.1-0.1l-0.3-0.6 c-0.1-0.1,0-0.3,0.2-0.3h0.5l0.1,0.1l0.3,1l0.5-0.1l0-0.2c0.1-1-0.3-1.6-0.7-2.3c-0.2-0.3-0.3-0.6-0.5-0.9c0.1,0.1,0.3,0.3,0.4,0.4 c0.8,0.8,1.3,1.7,1.5,2.9c0,0.2,0,0.3,0.1,0.5c0,0.1,0,0.2,0,0.3c0,0.9-0.3,1.7-0.6,2.4c0.5,0.2,1,0.4,1.4,0.7 c0.3,0.3,0.4,0.4,0.6,0.6C626.4,175.5,626.4,175.6,626.4,175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M619.1,162.1c0.5-0.1,2,3.1,2,3.4c-0.5-0.5-1.2-1.6-1.8-1.9c-0.1-0.1-0.3,0-0.2,0.2c0,0.4,0.1,0.7,0.2,1.1 c0,0.2,0.1,0.3,0.2,0.5l0.2,0.1c0.8,0.3,1.5,0.8,2,1.5l0,0c0.2,0.3,0.4,0.6,0.5,1c0.1,0.1,0.1,0.3,0.2,0.4l0,0.1l0.1,0.2l-0.1-0.1 l-0.1-0.1c-0.4-0.7-1.3-1.3-2-1.7c-0.4-0.1-0.8-0.2-1.2-0.3c-0.6-0.1-1.1,0-1.7,0.2c0.1,0,0.2,0,0.3,0c0.7,0.1,1.4,0.4,1.9,0.9 l0.2,0.2c0.1,0.1,0.2,0.3,0.3,0.5c-0.2-0.3-0.6-0.5-0.9-0.7c-0.3-0.1-0.6-0.2-0.9-0.2l-0.1,0c-0.2,0-0.5,0-0.7,0.1l0,0l-0.2,0.1 c-0.2,0.1-0.3,0.1-0.4,0.2l-0.1,0l-0.4-0.5l-0.1-0.1l-0.1-0.2l-0.1-0.1l-0.2,0.1l0.1,0.2l0,0.2l-0.5,0.5c-0.1,0.1-0.3,0.1-0.3-0.1 l-0.2-0.5l0-0.1l0.9-0.6l-0.3-0.4l-0.2,0.1c-1,0.3-1.4,0.9-1.9,1.5c-0.2,0.3-0.4,0.5-0.6,0.8c0.1-0.2,0.1-0.4,0.2-0.5 c0.5-1,1.1-1.9,2.1-2.5c0.1-0.1,0.3-0.2,0.5-0.2c0.1,0,0.2-0.1,0.3-0.1c0.8-0.3,1.7-0.4,2.5-0.4c0-0.5,0-1.1,0.2-1.5 c0.1-0.4,0.2-0.6,0.3-0.8C618.9,162.2,619,162.1,619.1,162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M609.9,175.4c-0.3-0.3,1.6-3.3,1.8-3.5c-0.2,0.7-0.8,1.8-0.7,2.5c0,0.1,0.2,0.2,0.3,0.1 c0.3-0.2,0.6-0.4,0.8-0.7c0.1-0.1,0.2-0.3,0.3-0.4l0-0.2c-0.2-0.8-0.1-1.7,0.2-2.5l0,0c0.1-0.3,0.3-0.7,0.5-1 c0.1-0.1,0.2-0.3,0.3-0.4l0.1-0.1l0.2-0.2l-0.1,0.1l0,0.1c-0.4,0.7-0.5,1.8-0.4,2.6c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.5,0.6,1,1,1.4 l-0.1-0.2c-0.3-0.6-0.4-1.4-0.2-2.1l0.1-0.2c0.1-0.2,0.1-0.3,0.2-0.5c-0.1,0.4-0.2,0.8-0.1,1.2c0,0.3,0.1,0.6,0.3,0.9l0,0.1 c0.1,0.2,0.3,0.4,0.4,0.5l0,0l0.2,0.1c0.1,0.1,0.3,0.2,0.4,0.3l0,0l-0.2,0.6l0,0.1l-0.1,0.2l-0.1,0.2l0.2,0.1l0.1-0.2l0.2-0.1 l0.7,0.2c0.1,0,0.2,0.2,0.1,0.3l-0.3,0.4l-0.1,0l-1-0.4l-0.2,0.4l0.2,0.2c0.8,0.7,1.5,0.7,2.3,0.8c0.3,0.1,0.7,0.1,1,0.1 c-0.2,0-0.4,0.1-0.6,0.1c-1.1,0.1-2.2,0.1-3.2-0.5c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.7-0.5-1.2-1.2-1.6-1.9 c-0.4,0.2-0.9,0.5-1.4,0.7c-0.4,0.1-0.6,0.2-0.8,0.2C610.1,175.5,610,175.5,609.9,175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M533,192.8L533,192.8c2.8,0,5,2.2,5,5v2.4c0,2.4-1.9,4.3-4.3,4.3h-3.7c-2.4,0-4.3-1.9-4.3-4.3 C525.6,196.1,528.9,192.8,533,192.8L533,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M46.6,98.6c0.1,0.6,0.7,1.1,1.4,1c0.6-0.1,1.1-0.7,1-1.3l0,0c-0.1-0.6-0.7-1.1-1.4-1 C46.9,97.4,46.5,98,46.6,98.6L46.6,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M57,97.2c0.1,0.6,0.7,1.1,1.3,1c0.6-0.1,1.1-0.7,1-1.3l0,0c-0.1-0.6-0.7-1.1-1.3-1C57.3,96,56.9,96.5,57,97.2 L57,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M140.6,101.6c0.1,0.6,0.7,1.1,1.4,1c0.6-0.1,1.1-0.7,1-1.3l0,0c-0.1-0.6-0.7-1.1-1.4-1 C140.9,100.4,140.5,101,140.6,101.6L140.6,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M151,100.2c0.1,0.6,0.7,1.1,1.3,1c0.6-0.1,1.1-0.7,1-1.3l0,0c-0.1-0.6-0.7-1.1-1.3-1 C151.3,99,150.9,99.5,151,100.2L151,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M303.6,97.6c0.1,0.6,0.7,1.1,1.4,1c0.6-0.1,1.1-0.7,1-1.3l0,0c-0.1-0.6-0.7-1.1-1.4-1 C303.9,96.4,303.5,97,303.6,97.6L303.6,97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M314,96.2c0.1,0.6,0.7,1.1,1.3,1c0.6-0.1,1.1-0.7,1-1.3l0,0c-0.1-0.6-0.7-1.1-1.3-1 C314.3,95,313.9,95.5,314,96.2L314,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M408.3,95.6c-0.1,0.6-0.7,1.1-1.3,1c-0.6-0.1-1.1-0.7-1-1.3l0,0c0.1-0.6,0.7-1.1,1.3-1 C407.9,94.4,408.4,95,408.3,95.6L408.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M397.9,94.2c-0.1,0.6-0.7,1.1-1.3,1c-0.6-0.1-1.1-0.7-1-1.3l0,0c0.1-0.6,0.7-1.1,1.3-1 C397.6,93,398,93.5,397.9,94.2L397.9,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M659.3,95.6c-0.1,0.6-0.7,1.1-1.3,1c-0.6-0.1-1.1-0.7-1-1.3l0,0c0.1-0.6,0.7-1.1,1.3-1 C658.9,94.4,659.4,95,659.3,95.6L659.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M648.9,94.2c-0.1,0.6-0.7,1.1-1.3,1c-0.6-0.1-1.1-0.7-1-1.3l0,0c0.1-0.6,0.7-1.1,1.3-1 C648.6,93,649,93.5,648.9,94.2L648.9,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M575.2,114.6c-0.1,0.6-0.7,1.1-1.3,1l0,0c-0.6-0.1-1.1-0.7-1-1.3l0,0c0.1-0.6,0.7-1.1,1.3-1l0,0 C574.9,113.4,575.3,113.9,575.2,114.6L575.2,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M566.9,112.2c-0.1,0.6-0.7,1.1-1.3,1l0,0c-0.6-0.1-1.1-0.7-1-1.3l0,0c0.1-0.6,0.7-1.1,1.3-1l0,0 C566.6,111,567,111.5,566.9,112.2L566.9,112.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M503.1,113.4c-0.2,0.6-0.8,1-1.5,0.8c-0.6-0.2-1-0.8-0.8-1.4l0,0c0.2-0.6,0.8-1,1.5-0.8 C502.9,112.1,503.3,112.8,503.1,113.4L503.1,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M493,110.7c-0.2,0.6-0.8,1-1.5,0.8c-0.6-0.2-1-0.8-0.8-1.4l0,0c0.2-0.6,0.8-1,1.5-0.8 C492.8,109.4,493.2,110.1,493,110.7L493,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M225.6,111.6c0.1,0.6,0.7,1.1,1.4,1c0.6-0.1,1.1-0.7,1-1.3l0,0c-0.1-0.6-0.7-1.1-1.4-1 C225.9,110.4,225.5,111,225.6,111.6L225.6,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M236,110.2c0.1,0.6,0.7,1.1,1.3,1c0.6-0.1,1.1-0.7,1-1.3l0,0c-0.1-0.6-0.7-1.1-1.3-1 C236.3,109,235.9,109.5,236,110.2L236,110.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 246.6,
    className: "st46",
    width: 0.4,
    height: 2.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "72.3,248.7 72.3,248.4 73.3,246.9 72.3,246.9 72.3,246.6 73.9,246.6 73.9,246.8 72.8,248.3  73.9,248.3 73.9,248.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M78.9,251.1c-0.1,0.4-2.7,0.5-3,0.5c0.5-0.2,1.5-0.4,1.9-0.7c0.1-0.1,0.1-0.2,0-0.2c-0.3-0.1-0.5-0.1-0.8-0.2 c-0.1,0-0.3,0-0.4,0l-0.1,0.1c-0.4,0.5-1,0.8-1.6,1h0c-0.3,0.1-0.6,0.1-0.8,0.1c-0.1,0-0.2,0-0.4,0l-0.1,0l-0.2,0l0.1,0l0.1,0 c0.6-0.1,1.3-0.5,1.8-0.9c0.2-0.2,0.4-0.5,0.5-0.7c0.2-0.4,0.3-0.8,0.4-1.3l-0.1,0.2c-0.2,0.5-0.7,0.9-1.2,1.1l-0.2,0.1 c-0.1,0-0.3,0.1-0.4,0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.2,0.3-0.4,0.4-0.6l0,0c0.1-0.2,0.1-0.3,0.1-0.5v0l0-0.2c0-0.1,0-0.3,0-0.4 l0,0l0.5-0.1l0.1,0l0.2,0l0.1,0l0-0.2l-0.2,0l-0.1-0.1l-0.2-0.5c0-0.1,0-0.2,0.1-0.2h0.4l0.1,0.1l0.2,0.8l0.3-0.1l0-0.2 c0-0.8-0.3-1.3-0.5-1.8c-0.1-0.2-0.3-0.5-0.4-0.7c0.1,0.1,0.2,0.2,0.3,0.3c0.6,0.6,1,1.3,1.2,2.2c0,0.1,0,0.3,0,0.4l0,0.3 c0,0.7-0.2,1.3-0.5,1.9c0.4,0.2,0.7,0.3,1,0.6c0.2,0.2,0.3,0.3,0.5,0.4C78.9,250.9,78.9,251,78.9,251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M73.3,240.6c0.4-0.1,1.5,2.4,1.6,2.6c-0.4-0.4-0.9-1.2-1.4-1.5c-0.1,0-0.2,0-0.2,0.1c0,0.3,0.1,0.5,0.1,0.8 c0,0.1,0.1,0.3,0.1,0.4l0.1,0.1c0.6,0.2,1.2,0.6,1.6,1.1l0,0c0.2,0.2,0.3,0.5,0.4,0.7c0,0.1,0.1,0.2,0.1,0.3l0,0.1l0,0.2l-0.1-0.1 l0-0.1c-0.3-0.5-1-1-1.6-1.3c-0.3-0.1-0.6-0.2-0.9-0.2c-0.4,0-0.9,0-1.3,0.1l0.2,0c0.5,0,1.1,0.3,1.4,0.7l0.1,0.1 c0.1,0.1,0.2,0.2,0.2,0.4c-0.2-0.2-0.4-0.4-0.7-0.5c-0.2-0.1-0.5-0.2-0.7-0.2l-0.1,0c-0.2,0-0.4,0-0.5,0.1h0l-0.2,0.1 c-0.1,0.1-0.2,0.1-0.3,0.2l0,0l-0.3-0.4l-0.1-0.1l-0.1-0.1l-0.1-0.1l-0.2,0.1l0.1,0.2l0,0.1l-0.4,0.4c-0.1,0.1-0.2,0.1-0.2,0 l-0.2-0.4l0-0.1l0.7-0.5l-0.2-0.3l-0.2,0.1c-0.8,0.3-1.1,0.7-1.5,1.2c-0.2,0.2-0.3,0.4-0.4,0.6c0-0.1,0.1-0.3,0.2-0.4 c0.3-0.8,0.8-1.5,1.6-1.9c0.1-0.1,0.2-0.1,0.4-0.2l0.2-0.1c0.6-0.3,1.3-0.3,1.9-0.3c0-0.4,0-0.8,0.1-1.2c0.1-0.3,0.1-0.4,0.2-0.6 C73.1,240.7,73.2,240.6,73.3,240.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M66.2,250.8c-0.3-0.3,1.2-2.5,1.4-2.7c-0.2,0.5-0.6,1.4-0.5,1.9c0,0.1,0.1,0.2,0.2,0.1 c0.2-0.2,0.4-0.3,0.6-0.5c0.1-0.1,0.2-0.2,0.3-0.3l0-0.1c-0.1-0.6-0.1-1.3,0.2-1.9l0,0c0.1-0.3,0.2-0.5,0.4-0.7 c0.1-0.1,0.1-0.2,0.2-0.3l0.1-0.1l0.1-0.1l-0.1,0.1l0,0.1c-0.3,0.5-0.4,1.4-0.3,2c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.4,0.5,0.8,0.8,1.1 l-0.1-0.2c-0.2-0.5-0.3-1.1-0.2-1.6l0.1-0.2c0-0.1,0.1-0.3,0.2-0.4c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.2,0.1,0.5,0.2,0.7l0,0.1 c0.1,0.2,0.2,0.3,0.3,0.4l0,0l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2l0,0l-0.2,0.4l0,0.1l-0.1,0.2l0,0.1l0.2,0.1l0.1-0.2l0.1,0l0.5,0.1 c0.1,0,0.1,0.1,0.1,0.2l-0.2,0.3l-0.1,0l-0.8-0.3l-0.1,0.3l0.1,0.1c0.6,0.5,1.2,0.5,1.8,0.6c0.3,0,0.5,0.1,0.8,0.1 c-0.1,0-0.3,0.1-0.4,0.1c-0.8,0.1-1.7,0-2.5-0.4c-0.1-0.1-0.2-0.1-0.3-0.2l-0.2-0.1c-0.5-0.4-0.9-1-1.2-1.5 c-0.3,0.2-0.7,0.4-1.1,0.5c-0.3,0.1-0.4,0.1-0.6,0.1C66.4,250.9,66.3,250.9,66.2,250.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeIzPartner);
export default __webpack_public_path__ + "static/media/become-iz-partner.ef93d721846c852fd9e6bf71076234b0.svg";
export { ForwardRef as ReactComponent };